export default "__VITE_ASSET__4hNXdGu9__"